import { Column, Entity, Index, JoinColumn, ManyToOne } from 'typeorm';
import { BaseEntity } from './base.entity';
import { TeamEntity } from './team.entity';
import { UserEntity } from './user.entity';

@Index('fk_team__id', ['fkTeamId'], {})
@Index('fk_user__id', ['fkUserId'], {})
@Entity('team_user')
export class TeamUserEntity extends BaseEntity {
	@Column('int', { name: 'fk_team__id', unsigned: true })
	public fkTeamId!: number;

	@Column('int', { name: 'fk_user__id', unsigned: true })
	public fkUserId!: number;

	@ManyToOne(() => TeamEntity, (team) => team.teamUsers, {
		onDelete: 'NO ACTION',
		onUpdate: 'NO ACTION',
	})
	@JoinColumn([{ name: 'fk_team__id', referencedColumnName: 'id' }])
	public fkTeam!: TeamEntity;

	@ManyToOne(() => UserEntity, (user) => user.teamUsers, {
		onDelete: 'NO ACTION',
		onUpdate: 'NO ACTION',
	})
	@JoinColumn([{ name: 'fk_user__id', referencedColumnName: 'id' }])
	public fkUser!: UserEntity;
}
